import { useEffect, useState } from "react";
import { axiosInstance } from "./config";

export const useSupplierCategories = () => {
  const [supplierCategories, setSupplierCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCategories = () => {
    setIsLoading(true);
    axiosInstance.get("supplier-categories").then((res) => {
      setSupplierCategories(res.data);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return { isLoading, supplierCategories, fetchCategories };
};

export const useSupplierSubCategories = () => {
  const [supplierSubCategories, setSupplierSubCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [parentId, setParentId] = useState(1);

  const fetchSupplierSubCategories = (parentId) => {
    setIsLoading(true);
    axiosInstance.get(`supplier-sub-categories/${parentId}`).then((res) => {
      setSupplierSubCategories(res.data);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    console.log({ parentId });
    parentId && fetchSupplierSubCategories(parentId);
  }, [parentId]);

  return {
    isLoading,
    supplierSubCategories,
    setParentId,
    fetchSupplierSubCategories,
  };
};
